module.exports = __webpack_public_path__ + "mobilemenuicon-plus.5d7affa1.svg";